export default "__VITE_ASSET__f35de55e__"